<template>
  <div>
    <Calendar 
      :isEventDataUrl="isEventDataUrl"
      :noEventDataUrl="noEventDataUrl"
      :measureUrl="measureUrl"
      >
    </Calendar>
  </div>
</template>

<script>
import Calendar from '@/components/Calendar'
import { fetch } from '@/utils/api'

export default {
  components: {
    Calendar
  },
  data () {
    return {
      isEventDataUrl: 'isEvent.json',
      noEventDataUrl: 'noEvent.json',
      measureUrl: 'measure.json'
    }
  },
  created () {
    // this.getCalendarBook()
    // this.getNoSchedulingBook()
  },
  methods: {
    // 获取日历上区本
    getCalendarBook () {
      fetch({
        method: 'get',
        url: 'isEvent.json',
        params: {
          id: 1,
          date: '2017-10'
        }
      })
      .then(data => {
        console.log(data)
        this.isEventData = data.data
      })
    },
    // 获取未排期区本
    getNoSchedulingBook () {
      fetch({
        method: 'get',
        url: 'noEvent.json',
        params: {
          id: 1,
          date: '2017-10'
        }
      })
      .then(data => {
        this.noEventData = data.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?2ed76456